import { useState } from 'react';
import { COMMON_MOBILE_BREAKPOINT, useWindowWidth } from '@elfsight/lib-utils';
import { useFilters } from '../../widget-filters-provider';
import { FiltersPane, type FiltersPaneProps } from './filters-pane';
import { FiltersPopup, type FiltersPopupProps } from './filters-popup';

type CommonOmittedKeys =
  | 'show'
  | 'onCloseRequest'
  | 'onOpenRequest'
  | 'onDiscardRequest'
  | 'onApplyRequest'
  | 'onResetRequest'
  | 'displayClearButton';

type FiltersModalProps =
  | ({ type: 'pane' } & Omit<FiltersPaneProps, CommonOmittedKeys>)
  | ({ type: 'popup' } & Omit<FiltersPopupProps, CommonOmittedKeys>);

export function FiltersModal({ type, ...props }: FiltersModalProps) {
  const Modal = type && { popup: FiltersPopup, pane: FiltersPane }[type];
  const width = useWindowWidth();
  const [open, setOpen] = useState(false);
  const {
    discardSelectedFilters,
    applySelectedFilters,
    resetFilters,
    filtersSelectedCount,
    clearSelectedFilters
  } = useFilters();

  const bindModal = {
    onOpenRequest: () => setOpen((prev) => !prev),
    onCloseRequest: () => setOpen(false),
    onApplyRequest: applySelectedFilters,
    onDiscardRequest: discardSelectedFilters,
    onClearRequest: clearSelectedFilters,
    onResetRequest: resetFilters,
    displayClearButton: filtersSelectedCount > 0
  };

  if (width < COMMON_MOBILE_BREAKPOINT) {
    return (
      <FiltersPopup
        {...props}
        margin={0}
        borderRadius={0}
        show={open}
        fullscreen
        {...bindModal}
      />
    );
  }

  return <Modal {...props} show={open} {...bindModal} />;
}
